module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento15.9becd0f2.svg";